import { useQuery } from "@tanstack/react-query";
import { getPublicDiagnosticReport } from "../api/diagnosticsApi";
import { PublicDiagnosticReportResponse } from "../types/diagnostics";

export const usePublicDiagnosticReport = (token: string | undefined) => {
  return useQuery<PublicDiagnosticReportResponse, Error>({
    queryKey: ["publicReport", token],
    queryFn: async () => {
      if (!token) {
        throw new Error("Token is required");
      }
      return getPublicDiagnosticReport(token);
    },
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
  });
};
